import React from "react";
import { useParams } from "react-router";
import { ToneDiagram } from "../chants/audio/ToneDiagram";
import { ChantExplorer } from "../chants/eb-chant/ChantExplorer";
import { useLocalStorage } from "../utils/local-storage";
import { SCAN_RESULTS } from "./scan-results";

export const AntiphonEditor: React.FC<{}> = () => {
    const { index } = useParams<{
        index: string;
    }>();

    const i = parseInt(index);

    const scanItem = SCAN_RESULTS[i];

    const [editValue, setEditValue] = useLocalStorage(
        `antiphon-${scanItem.title}`,
        { gabc: scanItem.gabc, tone: "", isDone: false }
    );

    return (
        <div
            style={{
                width: "100%",
                height: "100%",
                overflow: "hidden",
                display: "flex",
                flexDirection: "column",
                alignItems: "stretch",
            }}
        >
            <div style={{ display: "flex", flexDirection: "row" }}>
                <button
                    onClick={() => {
                        window.location.href = `/antiphon-editor/${i - 1}`;
                    }}
                >
                    Prev
                </button>
                <button
                    onClick={() => {
                        window.location.href = `/antiphon-editor/${i + 1}`;
                    }}
                >
                    Next
                </button>
                <div>{i}</div>
            </div>
            <div
                style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "stretch",
                    flexGrow: 1,
                    flexShrink: 1,
                    overflow: "hidden",
                }}
            >
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        overflow: "auto",
                        flexShrink: 0,
                    }}
                >
                    <img
                        src={`http://localhost:8080/${scanItem.filename}`}
                        style={{ width: 600 }}
                    />
                    <img
                        src={`http://localhost:8080/${scanItem.nextFileName}`}
                        style={{ width: 600 }}
                    />
                    <div style={{ paddingBottom: 1000 }}>npx http-server</div>
                </div>
                <div
                    style={{
                        padding: 8,
                        flexGrow: 1,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "stretch",
                        maxWidth: 600,
                    }}
                >
                    <ChantExplorer gabc={editValue.gabc} tone="8.1" />
                    <textarea
                        onChange={(event) => {
                            setEditValue({
                                ...editValue,
                                gabc: event.currentTarget.value,
                            });
                        }}
                        style={{ height: 300 }}
                    >
                        {editValue.gabc}
                    </textarea>
                    <ToneDiagram toneId={editValue.tone} highlightCount={0} />
                    <input
                        value={editValue.tone}
                        onChange={(event) => {
                            setEditValue({
                                ...editValue,
                                tone: event.currentTarget.value,
                            });
                        }}
                    />
                    <div style={{ display: "flex", flexDirection: "row" }}>
                        <input
                            type="checkbox"
                            id="done"
                            name="done"
                            checked={editValue.isDone}
                            onChange={() => {
                                setEditValue({
                                    ...editValue,
                                    isDone: !editValue.isDone,
                                });
                            }}
                        />
                        <label htmlFor="done">Done</label>
                    </div>
                    <div>
                        {JSON.stringify({
                            gabc: editValue.gabc,
                            tone: editValue.tone,
                        })}
                    </div>
                </div>
            </div>
        </div>
    );
};
